import { TableWithPaginationWrapper } from 'components/Table/styles'
import styled from 'styled-components'
import theme from 'theme_'

export const StyledTableInnerWrapper = styled.div`
  @media ${theme.devices.tablet} {
    min-width: 1000px;
  }
`

export const StyledTableOuterWrapper = styled(TableWithPaginationWrapper)`
  @media ${theme.devices.tablet} {
    margin-bottom: 24px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
    border-radius: 8px;
  }
`
